import axios from "@/libs/api.request";

export const getTypeList = data => {
  return axios.request({
    url: "goods/getTypeList",
    data: data,
    csrf: false,
    method: "post"
  });
};

export const storeTypeData = data => {
  return axios.request({
    url: "goods/storeTypeData",
    data: data,
    method: "post"
  });
};

export const removeTypeData = id => {
  return axios.request({
    url: "goods/removeTypeData",
    data: { id },
    method: "post"
  });
};

//商品定义的属性

export const getTypeAttributeList = filterCond => {
  return axios.request({
    url: "goods/getTypeAttributeList",
    data: filterCond,
    csrf: false,
    method: "post"
  });
};

export const storeTypeAttributeData = data => {
  return axios.request({
    url: "goods/storeTypeAttributeData",
    data: data,
    method: "post"
  });
};

export const removeTypeAttributeData = id => {
  return axios.request({
    url: "goods/removeTypeAttributeData",
    data: { id },
    method: "post"
  });
};

export const getBrandList = filterCond => {
  return axios.request({
    url: "goods/getBrandList",
    data: filterCond,
    csrf: false,
    method: "post"
  });
};

export const storeBrandData = data => {
  return axios.request({
    url: "goods/storeBrandData",
    data: data,
    method: "post"
  });
};

export const removeBrandData = id => {
  return axios.request({
    url: "goods/removeBrandData",
    data: { id },
    method: "post"
  });
};

export const getCategoryTreeTableData = filterCond => {
  return axios.request({
    url: "goods/getCategoryTreeTableData",
    data: filterCond,
    csrf: false,
    method: "post"
  });
};

export const getCategoryTreeSelect = () => {
  return axios.request({
    url: "goods/getCategoryTreeSelect",
    csrf: false,
    method: "post"
  });
};
export const storeCategoryData = data => {
  return axios.request({
    url: "goods/storeCategoryData",
    data: data,
    method: "post"
  });
};

export const removeCategoryData = id => {
  return axios.request({
    url: "goods/removeCategoryData",
    data: { id },
    method: "post"
  });
};

export const getTypePriceAttrList = filterCond => {
  return axios.request({
    url: "goods/getTypePriceAttrList",
    data: filterCond,
    csrf: false,
    method: "post"
  });
};

export const removeTypePriceAttrData = id => {
  return axios.request({
    url: "goods/removeTypePriceAttrData",
    data: { id },
    method: "post"
  });
};
export const storeTypePriceAttrData = data => {
  return axios.request({
    url: "goods/storeTypePriceAttrData",
    data: data,
    method: "post"
  });
};

//根据商品ID和定义获取价格属性
export const getGoodsTypePriceAttrList = (goodsid, typeid) => {
  return axios.request({
    url: "goods/getGoodsTypePriceAttrList",
    data: { goodsid, typeid },
    csrf: false,
    method: "post"
  });
};

export const storeGoodsData = (data, priceAttrData, galleryList) => {
  return axios.request({
    url: "goods/storeGoodsData",
    data: { data, priceAttrData, galleryList },
    method: "post"
  });
};

export const getGoodsList = filterCond => {
  return axios.request({
    url: "goods/getGoodsList",
    data: filterCond,
    csrf: false,
    method: "post"
  });
};

//删除商品价格属性
export const removeGoodsTypePriceAttrData = id => {
  return axios.request({
    url: "goods/removeGoodsTypePriceAttrData",
    data: { id },
    method: "post"
  });
};

export const removeGoodsData = id => {
  return axios.request({
    url: "goods/removeGoodsData",
    data: { id },
    method: "post"
  });
};

export const storeGoodsPriceData = data => {
  return axios.request({
    url: "goods/storeGoodsPriceData",
    data: data,
    method: "post"
  });
};

export const removeGoodsPriceData = id => {
  return axios.request({
    url: "goods/removeGoodsPriceData",
    data: { id },
    method: "post"
  });
};

export const getGoodsListByKeywords = keywords => {
  return axios.request({
    url: "goods/getGoodsListByKeywords",
    data: { keywords },
    csrf: false,
    method: "post"
  });
};

export const removeGalleryById = id => {
  return axios.request({
    url: "goods/removeGalleryById",
    data: { id },
    method: "post"
  });
};

export const getGoodsServiceList = () => {
  return axios.request({
    url: "goods/getGoodsServiceList",
    csrf: false,
    method: "post"
  });
};

export const getQuantityUnitList = () => {
  return axios.request({
    url: "goods/getQuantityUnitList",
    csrf: false,
    method: "post"
  });
};

export const storeGoodsDeliveryType = data => {
  return axios.request({
    url: "goods/storeGoodsDeliveryType",
    data: data,
    csrf: true,
    method: "post"
  });
};

export const removeGoodsDeliveryType = id => {
  return axios.request({
    url: "goods/removeGoodsDeliveryType",
    data: { id },
    csrf: true,
    method: "post"
  });
};

export const storeGoodsActivityData = data => {
  return axios.request({
    url: "goods/storeGoodsActivityData",
    data: data,
    csrf: true,
    method: "post"
  });
};
export const removeGoodsActivityData = id => {
  return axios.request({
    url: "goods/removeGoodsActivityData",
    data: { id },
    csrf: true,
    method: "post"
  });
};

export const cloneGoodsData = id => {
  return axios.request({
    url: "goods/cloneGoodsData",
    data: { id },
    csrf: true,
    method: "post"
  });
};

export const saveExchangeCardUploadFile = data => {
  return axios.request({
    url: "goods/saveExchangeCardUploadFile",
    data: data,
    csrf: true,
    method: "post"
  });
};

export const loadExchangeCardFileList = filterCond => {
  return axios.request({
    url: "goods/loadExchangeCardFileList",
    data: filterCond,
    csrf: false,
    method: "post"
  });
};

//处理兑换卡文件
export const storeExchangeCardFormFile = id => {
  return axios.request({
    url: "goods/storeExchangeCardFormFile",
    data: { id },
    csrf: true,
    method: "post"
  });
};

export const loadExchangeCardList = filterCond => {
  return axios.request({
    url: "goods/loadExchangeCardList",
    data: filterCond,
    csrf: false,
    method: "post"
  });
};
/**
 * 作废一张卡, 必须上传的人账号才可以
 */
export const cancelExchangeCard = id => {
  return axios.request({
    url: "goods/cancelExchangeCard",
    data: { id },
    csrf: true,
    method: "post"
  });
};
//作废一个卡的上传文件

export const cancelExchangeCardFile = id => {
  return axios.request({
    url: "goods/cancelExchangeCardFile",
    data: { id },
    csrf: true,
    method: "post"
  });
};
